var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"contentsr",attrs:{"endTime":_vm.endTime,"callback":_vm.callback,"endText":_vm.endText}},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.content)+" ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }